export interface Job {
  id: string;
  title: string;
  location: string;
  summary: string;
  responsibilities: string[];
  requirements: string[];
  benefits: string[];
  isOpen?: boolean;
}

const jobs: Job[] = [
  {
    id: "kaufmaennischer-mitarbeiter-vorbereitende-buchhaltung",
    title: "Kaufmännischer Mitarbeiter in der vorbereitenden Buchhaltung (m/w/d)*",
    location: "Teil-/Vollzeit • Berlin",
    summary:
      "Unterstützung in der Rechnungsprüfung, Kostenverfolgung und im Vertragswesen.",
    responsibilities: [
      "Erstellung der Rechnungsprüfblätter",
       "Anfertigung von Zahlungsanweisungen",
      "Anforderung von Vertragserfüllungs-, Vorauszahlungs- und Gewährleistungsbürgschaften",
  
     
     
      "Erfassung und Überwachung von Gewährleistungsfristen / Rückgabe von Bürgschaften",
      "Pflege der Kostenverfolgung",
      "Zusammenstellung von Unterlagen für Banken",
    ],
    requirements: [
      "Abgeschlossene kaufmännische Ausbildung, idealerweise als Kauffrau/-mann der Grundstücks- und Wohnungswirtschaft oder vergleichbare Qualifikation",
      "Berufserfahrung im Bau- oder Immobilienumfeld von Vorteil",
      "Sicherer Umgang mit MS Office (Outlook, Word, Excel)",
      "Sehr gute Deutschkenntnisse in Wort und Schrift",
      "Organisationsgeschick, Sorgfalt und Zuverlässigkeit",
      "Freude an der Arbeit im Team und mit Menschen",
    ],
    benefits: [
      "Ein abwechslungsreiches Aufgabengebiet in einem hilfsbereiten Team",
      "Eine leistungsgerechte Vergütung, freiwillige Prämien",
      "Einen modern ausgestatteten Arbeitsplatz",
      "Flexible Arbeitszeiten (Gleitzeit) und familienfreundliche Arbeitsbedingungen",
      "Ein familiäres Betriebsklima mit flachen Hierarchien und kurzen Wegen",
      "Kostenlose Teilnahme an Weiterbildungsmaßnahmen",
      "JobRad oder BVG-Ticket",
      "Firmenevents",
    ],
    isOpen: true,
  },

  {
    id: "projektassistenz",
    title: "Projektassistenz (m/w/d)*",
    location: "Teil-/Vollzeit • Berlin",
    summary:
      "Administrative und organisatorische Unterstützung der Projektleitung bei Bauprojekten.",
    responsibilities: [
      "Operative, administrative und organisatorische Unterstützung der Projektleitung",
      "Terminkoordination sowie Vor- und Nachbereitung von Meetings und Baubesprechungen",
      "Kommunikation mit allen am Bau Beteiligten (Architekten, Fachplaner, Behörden, Baufirmen)",
      "Protokollführung bei Bau- und Planungsbesprechungen",
      "Vorbereitung von Architekten-, Ingenieur- und Bauverträgen",
      "Planung von Dienstreisen und Reiseplänen",
      "Organisation und Koordination von Bauabnahmen",
    ],
    requirements: [
      "Abgeschlossene bautechnische Ausbildung oder vergleichbare Qualifikation ist vom Vorteil",
      "Erste Berufserfahrung im Assistenz- oder Projektumfeld, idealerweise in der Bau- oder Immobilienbranche",
      "Sicherer Umgang mit MS Office (Outlook, Word, Excel)",
      "Sehr gute Deutschkenntnisse sowie gute Englischkenntnisse in Wort und Schrift",
      "Organisationsgeschick, Zuverlässigkeit und Diskretion",
      "Freude an der Arbeit im Team und mit Menschen",
    ],
    benefits: [
      "Ein abwechslungsreiches Aufgabengebiet in einem hilfsbereiten Team",
      "Eine leistungsgerechte Vergütung, freiwillige Prämien",
      "Einen modern ausgestatteten Arbeitsplatz",
      "Flexible Arbeitszeiten (Gleitzeit) und familienfreundliche Arbeitsbedingungen",
      "Ein familiäres Betriebsklima mit flachen Hierarchien und kurzen Wegen",
      "Kostenlose Teilnahme an Weiterbildungsmaßnahmen",
      "JobRad oder BVG-Ticket",
      "Firmenevents",
    ],
    
    isOpen: true,
  },
];

export default jobs;